import { css } from '@linaria/core';
import theme from '../../../theme';

export const lines = css`
  line-clamp: var(--lines, 1);
  -webkit-line-clamp: var(--lines, 1);
  overflow: hidden;
  display: -webkit-box;
  word-break: break-all;
  -webkit-box-orient: vertical;
`;

export const typographies = {
  small: css`
    && {
      ${theme.typographies.small}
    }
  `,
  buttons: css`
    && {
      ${theme.typographies.buttons}
    }
  `,
  light: css`
    && {
      ${theme.typographies.light}
    }
  `,
  legal: css`
    && {
      ${theme.typographies.legal}
    }
  `,
  default: css`
    ${theme.typographies.default}
  `,
  menu: css`
    && {
      ${theme.typographies.menu}
    }
  `,
  title: css`
    && {
      ${theme.typographies.title}
    }
  `,
  big: css`
    && {
      ${theme.typographies.big}
    }
  `,
};

export const interactive = css``;

export const element = css`
  &.${interactive} {
    cursor: pointer;
  }
`;
